const CrossInRedCircle = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_13453_290)">
        <rect x="1" y="1" width="18" height="18" rx="9" fill="white" />
        <g clipPath="url(#clip1_13453_290)">
          <path
            d="M10 1.75C5.45077 1.75 1.75 5.45077 1.75 10C1.75 14.5492 5.45077 18.25 10 18.25C14.5492 18.25 18.25 14.5492 18.25 10C18.25 5.45077 14.5492 1.75 10 1.75ZM13.0381 12.0659C13.3069 12.3348 13.3069 12.7692 13.0381 13.0381C12.904 13.1722 12.7281 13.2395 12.5519 13.2395C12.376 13.2395 12.2 13.1722 12.0659 13.0381L10 10.9721L7.9341 13.0381C7.80003 13.1722 7.62405 13.2395 7.44806 13.2395C7.27195 13.2395 7.09596 13.1722 6.96189 13.0381C6.69313 12.7692 6.69313 12.3348 6.96189 12.0659L9.02792 10L6.96189 7.9341C6.69313 7.66521 6.69313 7.23078 6.96189 6.96189C7.23078 6.69313 7.66521 6.69313 7.9341 6.96189L10 9.02792L12.0659 6.96189C12.3348 6.69313 12.7692 6.69313 13.0381 6.96189C13.3069 7.23078 13.3069 7.66521 13.0381 7.9341L10.9721 10L13.0381 12.0659Z"
            fill="#FF0033"
          />
        </g>
      </g>
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="white" />
      <defs>
        <clipPath id="clip0_13453_290">
          <rect x="1" y="1" width="18" height="18" rx="9" fill="white" />
        </clipPath>
        <clipPath id="clip1_13453_290">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CrossInRedCircle;
